import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  BackArrow,
  Input,
  Select,
  Button,
  TopProgress,
  CheckBox,
} from '../../../../../components'
import {
  Container,
  TitleBig,
  CreateContainer,
} from './styles'
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useUi } from '../../../../../context/ui.context'
import { useTheme } from 'styled-components'
import { useAuth } from '../../../../../context/user.context'
import {openStackService} from '../../../../../api'

type ActionType = 'sync' | 'test-connection' | 'get-openrc'

const CreateFloatingIp:FC = () => {
  const [t] = useTranslation()
  const {viewAlert} = useUi()
  const {user} = useAuth()
  const theme:any = useTheme()
  const [initialValues, setInitialValues ] = useState<any>({
    auth_url:'',
    username:'',
    password:'',
    user_project_id:'',
    user_domain_id:'',
    default_interface:'',
    require_valid_ssl:'',
  })
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [settings, setSettings] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false)
  const onSubmit = async (values:any, action:ActionType) => {
    setLoading(true)
    console.log('action2', action);
    console.log('values2', values);
    const data = values
    if(!data.password){
      delete data.password
    }
    try{
      const res = await openStackService.saveOpenStackSettings(data)
      console.log('resdata',res.data);
      viewAlert({
        severity:'info',
        message:res?.data?.detail
      })
      setLoadingComplete(true)
      setTimeout(() => {
        setLoading(false)
        setLoadingComplete(false)
      },1500)
    } catch (e:any) {
      const errData = e?.response?.data
      const message = errData?.non_field_errors?.[0]
        || errData?.details
        || errData?.detail
        || t("ERROR_OCCURRED")
      viewAlert({
        severity:'error',
        message,
      })
      setLoading(false)
      setLoadingComplete(false)
    }
    
  }
  const {
    values,
    errors,
    touched,
    setErrors,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      auth_url: yup.string().required(`${t('REQUIRED_FIELD')}`),
      username: yup.string().required(`${t('REQUIRED_FIELD')}`),
      password: yup.string(),
      user_project_id: yup.string().required(`${t('REQUIRED_FIELD')}`),
      user_domain_id: yup.string().required(`${t('REQUIRED_FIELD')}`),
      default_interface: yup.string().required(`${t('REQUIRED_FIELD')}`),
      require_valid_ssl:yup.bool(),
      // certificate
    }),
    initialValues: {
      ...initialValues,
    },
    onSubmit:(values:any, action:any) => {
      console.log('action', action);
    console.log('values', values);
      onSubmit(values, action)},
  });
  
  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };
  const getData = async () => {
    try{
      const res = await openStackService.getOpenStackSettings()
      setSettings(res.data)
      setInitialValues(res.data)
      // setVerifyApiSsl(res.data.require_valid_ssl)
      setPageLoading(false)
    }catch(e:any){
      viewAlert({
        severity:'error',
        message:e?.response?.data?.detail || t("ERROR_OCCURED"),
      })
    }
  }
  useEffect(() => {
    getData()
  },[])

  const dataSelect = [
    {value:'public', label:'Public'},
    {value:'admin', label:'Admin'},
    {value:'private', label:'Private'},
  ]
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <CreateContainer>
      <Container>
        {/* <TitleBig>{t("CREATE_A_NEW_FLOATING_IP")}</TitleBig> */}
        <div style={{ display:'flex', flexDirection:'column', gap:'20px',marginTop:'20px', marginBottom:'20px'}}>
          <Input
            required
            fieldName='auth_url'
            toolTipText='The Keystone version 3 API URL used by Fleio to authenticate to OpenStack. The URL has the following form: https://keystone.url:5000/v3'
            toolTip={true}
            title={t("KEYSTONE_AUTH_URL")}
            placeholder=''
            {...formikProps}
          />
          <Input
            required
            fieldName='username'
            title={t("ADMIN_USERNAME")}
            placeholder=''
            {...formikProps}
          />
          <Input
            required
            fieldName='password'
            title={t("PASSWORD")}
            placeholder={t("PASSWORD_HIDDEN")}
            {...formikProps}
          />
          <Input
            required
            fieldName='user_project_id'
            title={t("ADMIN_PROJECT_ID")}
            placeholder=''
            {...formikProps}
          />
          <Input
            required
            fieldName='user_domain_id'
            title={t("ADMIN_DOMAIN_ID")}
            placeholder=''
            {...formikProps}
          />
          <Select
            toolTip={false}
            required
            data={dataSelect}
            selectedValue={values['default_interface']}
            onChange={(e) => handleChange('default_interface')(e)}
            title={t("DEFAULT_API_INTERFACE")}
            // customStyles={{marginBottom:'20px', width:'360px'}}
          />
          <CheckBox
            value={values['require_valid_ssl']}
            onChange={() => setFieldValue('require_valid_ssl', !values['require_valid_ssl'])}
            title={t("VERIFY_API_SSL")}
          />
          {values['require_valid_ssl'] &&
            <Input
              required
              fieldName='certificate'
              customStyles={{minWidth:'550px', maxWidth:'550px', height:'200px'}}
              isTextArea
              title={t("ADMIN_DOMAIN_ID")}
              placeholder=''
              {...formikProps}
            />
          }
        </div>
        <div style={{display:'flex', marginTop:'0px'}}>
          <Button
            variant='primary'
            size='display'
            customStyles={{ marginRight: '10px' }}
            //@ts-ignore
            onClick={() => handleSubmit('test-connection')}
            title={t('TEST_CONNECTION')}
            loading={loading}
            loadingComplete={loadingComplete}
          />
          <Button
            variant='primary'
            size='display'
            customStyles={{ marginRight: '10px' }}
            //@ts-ignore
            onClick={() => handleSubmit('get-openrc')}
            title={t('GET_OPENRC_FILE')}
            loading={loading}
            loadingComplete={loadingComplete}
          />
          <Button
            variant='secondary'
            size='display'
            customStyles={{ marginRight: '10px' }}
            //@ts-ignore
            onClick={() => handleSubmit('sync')}
            title={t('SYNC')}
            loading={loading}
            loadingComplete={loadingComplete}
          />
        </div>
      </Container>
    </CreateContainer>
  )
}

export default CreateFloatingIp